export const FilterToggle = ({ label, checked, onChange }) => {
    const toggle = () => onChange(!checked);

    return (
        <div className="archive-toggle">
            <span className="archive-toggle-label">{label}</span>
            <button
                type="button"
                className={`toggle-switch${checked ? ' toggle-switch--on' : ''}`}
                onClick={toggle}
                role="switch"
                aria-checked={checked}
                aria-label={label}
            >
                <span className="toggle-switch-thumb" />
            </button>
        </div>
    );
};
